import { IDocumentTemplate } from '@/interfaces';
import { DocumentState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';

export const mutations = {
  setThirdPartyPayment(state: DocumentState, payload: Blob) {
    state.third_party_payment = payload;
  },
  setDocumentTemplates(state: DocumentState, payload: IDocumentTemplate[]) {
    console.log('Setting document templates:', payload);
    state.document_templates = payload;
    console.log('Document templates set in state:', state.document_templates);
  },
};

const { commit } = getStoreAccessors<DocumentState, State>('');

export const commitSetThirdPartyPayment = commit(mutations.setThirdPartyPayment);
export const commitSetDocumentTemplates = commit(mutations.setDocumentTemplates);
